// 订购管理相关接口
import { sendPost } from '@/api/http.js'
import { get } from 'sortablejs'

const api = {
    'consume': '/exchange/plan/flow/consume', // 获取近日流量消耗情况
    'consumeList': '/exchange/plan/flow/consume/list', // 获取流量消耗列表
    'getWarpList': '/exchange/plan/list', // 套餐包列表 "type": 2=存储套餐,3=流量套餐
    'ConsumeInfo': '/exchange/plan/use/info', // 获取所有资源使用情况"type": 2=存储套餐,3=流量套餐
    'userInfo': '/user/user/info', // 获取所有资源使用情况"type": 2=存储套餐,3=流量套餐
    'RechargeRecord': '/exchange/plan/purchase/record', // 获取 存储空间-购买记录
    'planRecord': '/exchange/plan/purchase/plan/record', // 获取 流量中心-变更记录
    'getFuiyouUrl': '/exchange/plan/get_fuiyou_url', // 获取富友支付二维码
    'getFuiyouNBotify': '/exchange/fuiou_notify', // 获取富友支付回调
    'checkPayOrder': '/exchange/plan/check_fuiyou_pay_order', // 获取支付回调
}

export default {
    getConsume(params) {
        return sendPost(api.consume, params)
    },
    RechargeRecord(params) {
        return sendPost(api.RechargeRecord, params)
    },
    planRecord(params) {
        return sendPost(api.planRecord, params)
    },
    ConsumeList(params) {
        return sendPost(api.consumeList, params)
    },
    ConsumeInfo(params) {
        return sendPost(api.ConsumeInfo, params)
    },
    getFuiyouUrl(params) {
        return sendPost(api.getFuiyouUrl, params)
    },
    checkPayOrder(params) {
        return sendPost(api.checkPayOrder, params)
    },
    getWarpList(params) {
        return sendPost(api.getWarpList, params)
    },
    getUserInfo(params) {
        return sendPost(api.userInfo, params)
    },
}